import { render, staticRenderFns } from "./StateRouter.vue?vue&type=template&id=139f1dd0&"
import script from "./StateRouter.vue?vue&type=script&lang=js&"
export * from "./StateRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports